<tt-page *ngIf="!!edit">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input ttLabel="equipment_name" [ttModel]="edit.equipment_name" ttReadonly></tt-input>
        <tt-input ttLabel="oeestate_name" [ttModel]="edit.oeestate_name" ttReadonly></tt-input>
        <tt-checkbox ttLabel="include" [(ttModel)]="edit.include"></tt-checkbox>
        <tt-button-save ttText="save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
        <tt-button-goto [ttText]="'oeestateremarks'" [ttGoto]="'oeestateremarks'" [ttGotoParms]="{ oeestate_keyno: edit.oeestate_keyno }"></tt-button-goto>
    </tt-card>
</tt-page>

<!--<tt-page class="col-xs-12 sp-0">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input class="col-xs-12 sp-0" tt-label="equipment_name" tt-model="vm.model.edit.equipment_name" tt-change="vm.model.edit.equipment_name = $value" tt-readonly="true"></tt-input>
        <tt-input class="col-xs-12 sp-0" tt-label="oeestate_name" tt-model="vm.model.edit.oeestate_name" tt-change="vm.model.edit.oeestate_name = $value" tt-readonly="true"></tt-input>
        <tt-checkbox class="col-xs-12 sp-0" tt-label="include" tt-model="vm.model.edit.include" tt-change="vm.model.edit.include = $value"></tt-checkbox>
        <tt-button-save class="col-xs-12 sp-0" tt-text="save" tt-locked="vm.model.lockedSave" tt-click="vm.saveChanges()" tt-text-align="center"></tt-button-save>
        <tt-button-goto class="col-xs-12 sp-0" tt-text="oeestateremarks" tt-goto="oeestateremarks" tt-goto-parms="{ oeestate_keyno: vm.model.edit.oeestate_keyno }" tt-text-align="left"></tt-button-goto>
    </tt-card>
</tt-page>-->
